import { useTranslation } from 'react-i18next';

export function OfferViewForbiddenState() {
  const { t } = useTranslation('offers');

  return (
    <div data-testid="forbidden-message" className="flex h-full items-center justify-center py-20">
      <p className="text-muted-foreground">{t('access.forbidden')}</p>
    </div>
  );
}
